import { useAppSelector } from '../../store/hooks'
import { selectAuthErrors } from '../../store/auth/authSlice'
import React, { useEffect, useRef } from 'react'
import { Toast } from 'primereact/toast'
import { FULL_PAGE_ERROR_CODES } from '../../common/errorCodes'

export const AuthErrorToast: React.FC = () => {
  const authErrors = useAppSelector(selectAuthErrors)
  const toastRef = useRef<Toast>(null)

  useEffect(() => {
    const error = authErrors?.filter((error) => !FULL_PAGE_ERROR_CODES.includes(error.errorCode)).find((error) => error.message)?.message
    if (!error) {
      return
    }
    toastRef.current &&
      toastRef.current.show({
        severity: 'error',
        summary: 'Error',
        detail: (
          <div>
            Unable to complete the operation, reason: {error}. If the issue persists, please contact us at{' '}
            <a href='mailto:support@zocks.io' target='_blank' rel='noreferrer'>
              support@zocks.io
            </a>
          </div>
        ),
        life: 10000,
      })
  }, [authErrors])

  return <Toast ref={toastRef} />
}
